//this is a keeper.  navbar animations up top

import Headroom from "headroom.js";

const element = document.querySelector("body");
const options = {
    tolerance: {
        up: 50,
        down: 10
    },
}

const headroom = new Headroom(element, options);
headroom.init();